export const CODE = {
    OK_CODE: 200,
    CREATED: 201,
    BAD_REQUEST_CODE: 400,
    UNAUTHORIZED_CODE: 401,
    VALIDATION_CODE: 422,
    NO_CONTENT: 204,
    INTERNAL_SERVER_ERROR: 500
}

export const VALIDATION_MESSAGE = {
    CATCH_ERROR: "Something went wrong. Please try again.",
}


export const StorageConstants = {
    IS_USER_LOGIN_TOKEN: 'isUserLoginToken',
    USER_DETAIL: 'user_details',
    USER_REMEMBER_ME: "user_remember_me",
    APPROVAL_STATUS: "approval_status",
    APP_VAL: "app_val",
    USERTYPE: 2,
    USERTYPEAPP: 1,
    ROLE_TYPE:"role_type",

};


export const VerifyOtpTypes = {
    SignUp: 'signup',
    ForgotPassword: 'forgot',
    ContactVerify: "phone_verify"
}

export const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },
];

export const SocialTypes = {
    Google: 'GOOGLE',
    Facebook: 'FACEBOOK',
    Apple: 'APPLE',
};


export const VerifyMailType = {
    MailVerify: "MAIL_VERIFY",
    OtpVerify: "OTP_VERIFY",
    ForgetPasswordVerify: "FORGOT_PASSWORD",
    // :""

}

export const ProfileType = {
    CompanyProfile: 0,
    ProfileDetail: 1,
    CompleteProfile: 2,

}


export const Duration = {
    "00:00": "00:10",
    "00:10": "00:20",
    "00:20": "00:30",
    "00:30": "00:40",
    "00:40": "00:50",
    "00:50": "01:00",
    "01:00": "01:10",
    "01:10": "01:20",
    "01:20": "01:30",
    "01:30": "01:40",
    "01:40": "01:50",
    "01:50": "02:00",
    "02:00": "02:10",
    "02:10": "02:20",
    "02:20": "02:30",
    "02:30": "02:40",
    "02:40": "02:50",
    "02:50": "03:00",
    "03:00": "03:10",
    "03:10": "03:20",
    "03:20": "03:30",
    "03:30": "03:40",
    "03:40": "03:50",
    "03:50": "04:00"
}
export const durationOptions = [
    { label: '00:10', value: '00.10' },
    { label: '00:20', value: '00.20' },
    { label: '00:30', value: '00.30' },
    { label: '00:40', value: '00.40' },
    { label: '00:50', value: '00.50' },
    { label: '01:00', value: '01.00' },
    { label: '01:10', value: '01.10' },
    { label: '01:20', value: '01.20' },
    { label: '01:30', value: '01.30' },
    { label: '01:40', value: '01.40' },
    { label: '01:50', value: '01.50' },
    { label: '02:00', value: '02.00' },
    { label: '02:10', value: '02.10' },
    { label: '02:20', value: '02.20' },
    { label: '02:30', value: '02.30' },
    { label: '02:40', value: '02.40' },
    { label: '02:50', value: '02.50' },
    { label: '03:00', value: '03.00' },
    { label: '03:10', value: '03.10' },
    { label: '03:20', value: '03.20' },
    { label: '03:30', value: '03.30' },
    { label: '03:40', value: '03.40' },
    { label: '03:50', value: '03.50' },
    { label: '04:00', value: '04.00' },
    { label: '04:10', value: '04.10' },
    { label: '04:20', value: '04.20' },
    { label: '04:30', value: '04.30' },
    { label: '04:40', value: '04.40' },
    { label: '04:50', value: '04.50' },
    { label: '05:00', value: '05.00' },
];

export const PAGES = {
    pageIndex: 0,
    pageSize: 10,
}


export const MRT_Localization_AL = {
    rows: 'Rreshta',
    rowsPerPage: 'Rreshta për faqe',
    previous: 'E mëparshme',
    page: 'Faqe',
    noData: 'Nuk ka të dhëna',
}
